import axios from '@dap/shared-utils/http.js';
const jsonConfig = {
    headers: { 'Content-Type': 'application/json' },
};

export default {
    getVideoCoverList (params = {}) {
        return axios.get('/dapper/api/materiel_2/covers', { params });
    },

    addTag (params = {}) {
        return axios.post('/dapper/api/materiel_2/tags', params);
    },

    getTagsList (params = {}) {
        return axios.get('/dapper/api/materiel_2/tags', { params });
    },

    getImageList (params = {}) {
        return axios.get('/dapper/api/materiel_2/imagelist', { params });
    },

    updateMaterial (params = {}) {
        const suffix = !!params.materiel_id ? 'edit' : 'add';
        return axios.post(`/dapper/api/materiel_2/${suffix}`, params);
    },

    getMaterielEditInfo (params = {}) {
        return axios.get('/dapper/api/materiel_2/edit', { params });
    },

    getVendorList () {
        return axios.get('/dapper/api/materiel_2/vendor');
    },

    getMaterielInfo (params = {}) {
        return axios.get('/dapper/api/materiel_2/materiel_info', { params });
    },

    getYoutubeConfig (params = {}) {
        return axios.get('/dapper/api/materiel_2/upload_youtube_config', {
            params,
        });
    },

    reuplaodYoutube (params = {}) {
        return axios.post('/dapper/api/materiel_2/reupload_youtube', params);
    },

    getRequestDemandsList (params = {}) {
        return axios.get('/dapper/api/materiel_2/request-demands', { params });
    },

    getMaterialUsersList (params = {}) {
        return axios.get('/dapper/api/materiel_2/material-users', { params });
    },

    getTagList (params = {}) {
        return axios.get('/coach/api/tag_config/tag_list', { params });
    },
    getTagById (params = {}) {
        return axios.get('/coach/api/tag_config/tag', { params });
    },

    getMaterialDict (params = {}) {
        return axios.get('/dapper/api/materiel_2/material-dict', { params });
    },

    getMaterialDictV2 (params = {}) {
        return axios.get('/dapper/api/materiel_2/material-dict_v2', { params });
    },

    getMaterielInfoPreview (params = {}) {
        return axios.get('/dapper/api/materiel_2/material-info-preview', {
            params,
        });
    },

    getProducerList (params = {}) {
        return axios.get('/dapper/api/materiel_2/producer', { params });
    },

    // 获取衍生素材分类
    getExtendList (params = {}) {
        return axios.get('/coach/api/material_derivation/derived_classification', {
            params: {
                is_tree: 1,
                ...params,
            },
        });
    },

    uploadCsv (params) {
        return axios.post('/dapper/api/materiel_2/decrypt_material_name', params, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    csvExample () {
        return axios.get('/dapper/api/materiel_2/download_encrypted_name_example');
    },
    // 批量设置代理商
    batchVendor (params) {
        return axios.post('/dapper/api/materiel_2/vendor', params, jsonConfig);
    },

    // 编辑接口拆分
    setStatus: (params) => axios.put('/dapper/api/materiel_2/status', params),
    setName: (params) => axios.put('/dapper/api/materiel_2/name', params),
    setRemark: (params) => axios.put('/dapper/api/materiel_2/remark', params),
    setTags: (params) => axios.put('/dapper/api/materiel_2/tags', params),
};
